import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Hand = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M16.25 7.75V7.25C16.25 6.42157 16.9216 5.75 17.75 5.75C18.5784 5.75 19.25 6.42157 19.25 7.25V14.2354C19.25 18.1094 16.1094 21.25 12.2354 21.25C9.32487 21.25 6.71671 19.4527 5.68043 16.7329L3.25 10.3542C3.73657 9.15947 5.3114 8.89654 6.15969 9.86836L7.25 11.1175V5.25C7.25 4.42157 7.92157 3.75 8.75 3.75C9.57843 3.75 10.25 4.42157 10.25 5.25V11M10.25 9.75V4.25C10.25 3.42157 10.9216 2.75 11.75 2.75C12.5784 2.75 13.25 3.42157 13.25 4.25V11.5M13.25 7.75V5.25C13.25 4.42157 13.9216 3.75 14.75 3.75C15.5784 3.75 16.25 4.42157 16.25 5.25V12'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.0673 2C11.4414 2 10.934 2.50447 10.934 3.12676V9.88732C10.934 10.1985 10.6803 10.4507 10.3674 10.4507C10.0545 10.4507 9.80077 10.1985 9.80077 9.88732V4.25352C9.80077 3.63123 9.2934 3.12676 8.66753 3.12676C8.04165 3.12676 7.53428 3.63123 7.53428 4.25352V11.1464C7.53428 11.3763 7.39386 11.5831 7.17946 11.669C6.96506 11.7549 6.71966 11.7027 6.55938 11.5371L5.21282 10.1458C4.43664 9.34385 3.10627 9.49382 2.53035 10.4482L2.5 10.4985L5.29405 17.2834C6.46887 20.1363 9.26174 22 12.3623 22C16.5805 22 20 18.6 20 14.406V6.50704C20 5.88475 19.4926 5.38028 18.8668 5.38028C18.2409 5.38028 17.7335 5.88475 17.7335 6.50704V11.0141C17.7335 11.3252 17.4798 11.5775 17.1669 11.5775C16.8539 11.5775 16.6003 11.3252 16.6003 11.0141V4.25352C16.6003 3.63123 16.0929 3.12676 15.467 3.12676C14.8411 3.12676 14.3338 3.63123 14.3338 4.25352V10.4507C14.3338 10.7619 14.0801 11.0141 13.7671 11.0141C13.4542 11.0141 13.2005 10.7619 13.2005 10.4507V3.12676C13.2005 2.50447 12.6931 2 12.0673 2Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
